import Translation from './translation'

export default class Album extends Translation
{

    constructor(album, currentLocale = null){
        super()
        this.id             = 0

        this.locales        = []

        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.description_ar     = null
        this.description_en     = null
        this.description_fa     = null

        this.map(album, currentLocale)
        this.init()
    }

    map(album, currentLocale = null){
        if(album == undefined) return
        this.id             = album.id
        
        this.created_at     = album.created_at  
        this.updated_at     = album.updated_at  
        this.published_at   = album.published_at  

        for (let locale in album.translations) {
            this['title_' + locale] = album.translations[locale].title
            this['description_' + locale] = album.translations[locale].description
            this.locales.push(locale);
        }

        if(currentLocale != null){
            this.current_locale = currentLocale
        }else{
            this.setLocale(this.locales)
        }
    }
}

